import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import UploadPage from "./pages/UploadPage";
import StoresPage from "./pages/StoresPage";
import CreateStorePage from "./pages/CreateStorePage";
import CouponsPage from "./pages/CouponsPage";
import CategoriesPage from "./pages/CategoriesPage";
import LoginPage from "./pages/LoginPage";
import BlogTypeSelection from "./pages/BlogTypeSelection";
import BlogList from "./pages/BlogList";
import BlogEditor from "./pages/BlogEditor";
import PageTypeSelection from "./pages/PageTypeSelection";
import PageList from "./pages/PageList";
import PageEditor from "./pages/PageEditor";
import SubscribersPage from "./pages/SubscribersPage";
import Sidebar from "./components/Sidebar";
import Spinner from "./components/Spinner";
import { AuthProvider, useAuth } from "./context/AuthContext";
/*new*/
/* ── Protected route wrapper ────────────────────────── */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

/* ── Main layout (sidebar + routes) ─────────────────── */
const AppRoutes = () => {
  const { isAuthenticated, logout } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 600);
  }, []);

  if (loading) return <Spinner />;

  return (
    <Router>
      <Routes>
        {/* Public route */}
        <Route
          path="/login"
          element={
            isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />
          }
        />

        {/* Protected routes */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <div className="flex min-h-screen">
                <Sidebar />
                <div className="flex-1 relative">
                  <Routes>
                    <Route path="/" element={<Dashboard signOut={logout} />} />
                    <Route path="/upload" element={<UploadPage />} />
                    <Route path="/stores" element={<StoresPage />} />
                    <Route path="/create-store" element={<CreateStorePage />} />
                    <Route path="/coupons" element={<CouponsPage />} />
                    <Route path="/categories" element={<CategoriesPage />} />
                    <Route path="/subscribers" element={<SubscribersPage />} />
                    <Route path="/create-blog" element={<BlogTypeSelection />} />
                    <Route path="/edit-blog" element={<BlogList />} />
                    <Route path="/create-blog/:type" element={<BlogEditor />} />
                    <Route path="/edit-blog/:id" element={<BlogEditor />} />
                    <Route path="/create-page" element={<PageTypeSelection />} />
                    <Route path="/edit-page" element={<PageList />} />
                    <Route path="/create-page/:type" element={<PageEditor />} />
                    <Route path="/edit-page/:id" element={<PageEditor />} />
                    <Route path="*" element={<Navigate to="/" />} />
                  </Routes>
                </div>
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

/* ── Root component ─────────────────────────────────── */
const App = () => (
  <AuthProvider>
    <AppRoutes />
  </AuthProvider>
);

export default App;
